import { render } from "./CarFax.vue?vue&type=template&id=b3d968aa&scoped=true"
import script from "./CarFax.vue?vue&type=script&lang=js"
export * from "./CarFax.vue?vue&type=script&lang=js"

import "./CarFax.vue?vue&type=style&index=0&id=b3d968aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d968aa"]])

export default __exports__